module.exports = __webpack_public_path__ + "img/workspace-onboarding/upload-a-video-636214694d7edc4d49310fe56d19184a.png";